import jssVariables from "../../jss_setup";

export const navbar = {
  menuItem: {
    fontWeight: 500,
    "& h4": {
      fontWeight: 500,
      textTransform: "uppercase",
      fontSize: "large",
    },
    "& strong": {
      fontWeight: 500,
      textTransform: "uppercase",
      fontSize: "large",
    },
  },
  item: {
    smallscreen: {
      color: jssVariables.colors.base_color,
      textTransform: "uppercase",
      fontSize: "small",
      fontWeight: 600,
      borderBottom: "1px solid transparent",
      "& strong": {
        fontWeight: 600,
      },
      "&:hover": {
        textDecoration: "none",
        borderColor: jssVariables.colors.base_color,
      },
    },
  },
};
